import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { useTranslation } from "react-i18next"

export const TabHeader = ({
    icon,
    iconClassName,
    title,
    currentMode,
    mode,
    className,
    setActiveMode,
}: {
    title: string
    icon?: Icons.IconComponent
    iconClassName?: string
    currentMode: string
    mode: string
    className?: string
    setActiveMode: (mode: string) => void
}) => {
    const { t } = useTranslation()

    const isActive = currentMode === mode
    return (
        <div
            onClick={() => {
                if (mode !== currentMode) setActiveMode(mode)
            }}
            className={classNames(
                "flex justify-center items-center gap-1.5 py-3 px-3 border-b-[2px] cursor-pointer pointer-events-auto",
                {
                    "border-blue-500 text-gray-0": isActive,
                    "border-gray-700 text-gray-100": !isActive,
                },
                className
            )}
        >
            {icon && (
                <Icons.Icon
                    Icon={icon}
                    className={classNames(
                        "text-gray-400",
                        { "text-blue-500": isActive },
                        iconClassName
                    )}
                />
            )}
            <h5>{t(title)}</h5>
        </div>
    )
}
